import { FeatureToggleClientService } from 'feature-toggle-client';
const searchLogs = 'search-logs';
const showMessageLogsSwitch = 'show-message-logs-switch';
export class MessagesFeatures {
    static isSearchLogsEnabled() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(searchLogs, false);
    }
    static isSwitchLogsEnabled() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(showMessageLogsSwitch, false);
    }
}
